import { axios, defaultAxios } from 'utils/axios';
import { WEATHER_API_KEY } from 'config';

// Use defaultAxios for external weather API only
const fetchWeatherDetails = async (locationOrCoords) => {
    if (!locationOrCoords) {
        return null;
    }
    try {
        let query;
        if (typeof locationOrCoords === 'string') {
            query = locationOrCoords;
            if (locationOrCoords.includes(',')) {
                const [city, country] = locationOrCoords.split(',');
                query = `${city.trim()},${country.trim()}`;
            }
            if (!query.includes('India')) {
                query = `${locationOrCoords}, India`;
            }
        } else if (locationOrCoords.latitude && locationOrCoords.longitude) {
            query = `${locationOrCoords.latitude},${locationOrCoords.longitude}`;
        } else {
            throw new Error('Invalid location or coordinates');
        }
        const response = await defaultAxios.get(`https://api.weatherapi.com/v1/current.json?q=${query}&key=${WEATHER_API_KEY}&aqi=no`);
        return {
            current: response.data.current,
            location: response.data.location
        };
    } catch (error) {
        console.error('Error fetching weather details:', error);
        return {
            current: {
                temp_c: 25, // Default temperature
                humidity: 50 // Default humidity
            },
            location: {
                name: typeof locationOrCoords === 'string' ? locationOrCoords : 'Unknown Location',
                country: 'Unknown Country'
            }
        };
    }
};

// Fetch available translation language keys from backend
const getLanguageKeys = () => {
    return axios.get('api/translation/language-keys');
};

export {
    fetchWeatherDetails,
    getLanguageKeys,
};

// Export all methods from their respective modules
export * from './safetynow';
export * from './safetybuddy';
export * from './safetyguru';
export * from './calculators';
